/**
 * Domains the cloud site answers on. The first is the site's home; the CDN
 * forwards every request on the others to the same subdomain + path on it.
 * Mirrors backend/lib/site-domains.ts (SITE_ROOT, then FORWARDED_ROOTS);
 * backend/lib/__tests__/site-domains.test.js fails if the two drift.
 */
export const SITE_ROOTS = ['teamy.town', 'zibby.dev', 'zibby.app'];

/** The site root `hostname` sits under, or null (localhost, CDN host, …). */
export const siteRootOf = (hostname) =>
  SITE_ROOTS.find((root) => hostname === root || hostname.endsWith(`.${root}`)) || null;

/** True on a root or www. host — the marketing hosts, not the studio. app. */
export const isRootSiteHost = (hostname) => {
  const root = siteRootOf(hostname);
  return !!root && (hostname === root || hostname === `www.${root}`);
};
